document.querySelectorAll(".smooth-accordion details").forEach((detail) => {
  const summary = detail.querySelector("summary");
  const content = detail.querySelector(".accordion__content");
  let isAnimating = false;

  summary.addEventListener("click", (e) => {
    e.preventDefault(); // prevent instant toggle

    if (isAnimating) return;
    isAnimating = true;

    const isOpen = detail.hasAttribute("open");
    
    if (!isOpen) {
      // OPENING
      detail.setAttribute("open", "");
      content.style.maxHeight = "0";
      content.offsetHeight; // force reflow

      content.style.transition = "max-height 0.4s ease, opacity 0.4s ease";
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.opacity = "1";

      content.addEventListener(
        "transitionend",
        () => {
          content.style.maxHeight = "none";
          isAnimating = false;
        },
        { once: true }
      );
    } else {
      // CLOSING
      const endHeight = content.scrollHeight;
      content.style.maxHeight = endHeight + "px";
      content.offsetHeight; // reflow

      content.style.transition = "max-height 0.4s ease, opacity 0.4s ease";
      content.style.maxHeight = "0";
      content.style.opacity = "0";

      content.addEventListener(
        "transitionend",
        () => {
          detail.removeAttribute("open");
          content.style.maxHeight = "0";
          isAnimating = false;
        },
        { once: true }
      );
    }
  });
});
